export const GET_SUB_DEALR_SUCESS= "GET_SUB_DEALR_SUCESS"
export const GET_SUB_DEALR_FAIL= "GET_SUB_DEALR_FAIL"

export const GET_SUB_DEALER_CONTACT_REQUEST = "GET_SUB_DEALER_CONTACT_REQUEST";
export const GET_SUB_DEALER_CONTACT_SUCCESS = "GET_SUB_DEALER_CONTACT_SUCCESS";
export const GET_SUB_DEALER_CONTACT_FAIL = "GET_SUB_DEALER_CONTACT_FAIL";
export const GET_DEALER_RELATION_FAIL = "GET_DEALER_RELATION_FAIL";
export const GET_DEALER_RELATION_SUCCESS = "GET_DEALER_RELATION_SUCCESS";
export const GET_SUB_DEALR_LIST_REQUEST = "GET_SUB_DEALR_LIST_REQUEST";
export const GET_DEALER_RELATION_REQUEST = "GET_DEALER_RELATION_REQUEST";

export const GET_POINT_CALCULATION_AUTO_REQUEST = "GET_POINT_CALCULATION_AUTO_REQUEST";
export const GET_POINT_CALCULATION_AUTO_FAIL = "GET_POINT_CALCULATION_AUTO_FAIL";
export const GET_POINT_CALCULATION_AUTO_SUCCESS = "GET_POINT_CALCULATION_AUTO_SUCCESS";
export const GET_POINT_CALCULATION_MANUAL_REQUEST = "GET_POINT_CALCULATION_MANUAL_REQUEST";
export const GET_POINT_CALCULATION_MANUAL_FAIL = "GET_POINT_CALCULATION_MANUAL_FAIL";
export const GET_POINT_CALCULATION_MANUAL_SUCCESS = "GET_POINT_CALCULATION_MANUAL_SUCCESS";

export const GET_ALLOCATION_INVENTORY_REQUEST = "GET_ALLOCATION_INVENTORY_REQUEST";
export const GET_ALLOCATION_INVENTORY_FAIL = "GET_ALLOCATION_INVENTORY_FAIL";
export const GET_ALLOCATION_INVENTORY_SUCCESS = "GET_ALLOCATION_INVENTORY_SUCCESS";